import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=7427d502&scoped=true&"
import script from "./SettingsCard.vue?vue&type=script&lang=js&"
export * from "./SettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCard.vue?vue&type=style&index=0&id=7427d502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7427d502",
  null
  
)

export default component.exports